import { ThemeConfig, theme } from "antd";

export const GluceraTheme: ThemeConfig = {
  algorithm: theme.defaultAlgorithm,
  token: {
    // Ensure light theme
    colorTextBase: "#1f2937",
    colorBgBase: "#ffffff",
    colorBgContainer: "#ffffff",
    colorBgLayout: "#ffffff",
    fontSize: 16,
    borderRadius: 10,
  },
  components: {
    // Only styles that won't interfere with custom components
    Typography: {
      colorTextBase: "#66697c",
    },
    Tooltip: {
      colorBgSpotlight: "#66697C",
    },
  },
};
